import { Component } from '@angular/core';

@Component({
  selector: 'payment-link-expired',
  templateUrl: './payment-link-expired.component.html',
  styleUrls: ['./payment-link-expired.component.scss'],
})
export class PaymentLinkExpiredComponent {
  constructor() {}
}
